import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Address } from '@df/session/api/address-book/address';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { AddressNamePipe } from '../../../ui/account/address-name.pipe';
import { Section2Component } from '../../../ui/display/section2/section2.component';
import { AccountAddressBodyComponent } from '../body/account-address-body.component';
@Component({
    selector: 'account-address-item',
    templateUrl: './account-address-item.html',
    styleUrls: ['account-address-item.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [AccountAddressBodyComponent, Section2Component, TranslationModule, AddressNamePipe]
})
export class AccountAddressItemComponent {
    /**
     * Adddress model
     */
    @Input()
    address?: Address;
    get infoMsg(): string | undefined {
        if (this.address?.is_billing && this.address.is_shipping) {
            return 'Primary';
        }
        if (this.address?.is_billing) {
            return 'Primary Billing';
        }
        if (this.address?.is_shipping) {
            return 'Primary Delivery';
        }
    }
}
